///<amd-module name="typeahead/core/google/AddressAutocompleteFailureMetric" />

import {TypeaheadMetric} from "typeahead/core/logging/TypeaheadMetric";

export class AddressAutocompleteFailureMetric extends TypeaheadMetric {

    constructor(lob: string,
                elementId: string,
                public userTypedQuery: string,
                public status: string,
                activeESSTests: string) {
        super(lob, elementId, "AddressAutocompleteFailure", activeESSTests);
    }
}
